import api from "@services/api";
import apiNotification from "@services/apiNotification";
import axios, { AxiosError } from "axios";
import {
  IConvertLeadSchema,
  ICreateOportunitySchema,
  ICreatePersonLegalSchema,
  ICreatePersonPhisycalSchema,
  IGetAccountByIdSchema,
  IGetOportunityByIdSchema,
  IGetOportunitySchema,
  IGetSalesSchema,
  IUpdateAccount,
  IUpdateAdress,
} from "src/@types/Sales";

class SalesService {
  async getSales({ email, telefone, CPFCNPJ }: IGetSalesSchema) {
    const body = {
      email,
      telefone,
      CPFCNPJ,
    };

    const handleOption = () => {
      if (email === "email") return "email";
      if (telefone === "telefone") return "telefone";
      if (CPFCNPJ === "CPFCNPJ") return "CPFCNPJ";
    };

    const tipoChave = handleOption();
    const chave = email || telefone || CPFCNPJ;

    try {
      const response = await api.get("/conta/obter", {
        params: body,
      });

      return response.data
        .map((d: any) => ({ ...d, tipoChave, chave }))
        .filter((d: any) => d.leadConvertido !== true);
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async createPersonPhisycal({
    idCorretorSalesforce,
    tipoRegistro,
    tratamento,
    nomeDaConta,
    regional,
    regionalComercial,
    unidadeDeNegocio,
    telefonePrincipal,
    emailPrincipal,
    renda,
    telefoneComplementar,
    emailComplementar,
    campanha,
    melhorHorarioDeAtendimento,
    finalidadeDaCompra,
    detalhesPodeMorar,
    tipoDeTrabalho,
    numeroDeFilhos,
    observacoes,
    origemDaConta,
    empreendimentoDeInteressePrincipal,
    numeroDeQuartos,
    numeroDeVagas,
    telefoneComplementarEhWhatsapp,
    telefoneComplementarEhCelular,
    telefonePrincipalEhWhatsapp,
    telefonePrincipalEhCelular,
    cpf,
    dataExpedicaoRG,
    dataNascimento,
    estadoCivil,
    nacionalidade,
    orgaoExpedidorRG,
    profissao,
    rg,
    criarOportunidade,
    sexo,
    dataCasamento,
    regimeCasamento,
  }: ICreatePersonPhisycalSchema) {
    const body = {
      idCorretorSalesforce,
      tipoRegistro,
      origemDaConta,
      tratamento,
      nomeDaConta,
      regional,
      regionalComercial,
      unidadeDeNegocio,
      telefonePrincipal,
      emailPrincipal,
      renda,
      telefoneComplementar,
      emailComplementar,
      campanha,
      melhorHorarioDeAtendimento,
      finalidadeDaCompra,
      detalhesPodeMorar,
      tipoDeTrabalho,
      numeroDeFilhos,
      observacoes,
      empreendimentoDeInteressePrincipal,
      numeroDeQuartos,
      numeroDeVagas,
      telefoneComplementarEhWhatsapp,
      telefoneComplementarEhCelular,
      telefonePrincipalEhWhatsapp,
      telefonePrincipalEhCelular,
      cpf,
      dataExpedicaoRG,
      dataNascimento,
      estadoCivil,
      nacionalidade,
      orgaoExpedidorRG,
      profissao,
      rg,
      criarOportunidade,
      sexo,
      dataCasamento,
      regimeCasamento,
    };

    try {
      const response = await api.post("/conta/criar-pessoa-fisica", body);

      return response;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async createPersonLegal({
    idCorretorSalesforce,
    tipoRegistro,
    nomeDaConta,
    nomeFantasia,
    regional,
    inscricaoEstadual,
    inscricaoMunicipal,
    cnpj,
    nire,
    regionalComercial,
    unidadeDeNegocio,
    telefonePrincipal,
    emailPrincipal,
    dataDeFundacao,
    detalhesPodeMorar,
    emailComplementar,
    finalidadeDaCompra,
    tipoDeTrabalho,
    observacoes,
    telefonePrincipalEhWhatsapp,
    telefonePrincipalEhCelular,

    origemDaConta,
    empreendimentoDeInteressePrincipal,
    numeroDeQuartos,
    numeroDeVagas,
    criarOportunidade,
  }: ICreatePersonLegalSchema) {
    const body = {
      idCorretorSalesforce,
      tipoRegistro,
      nomeDaConta,
      nomeFantasia,
      regional,
      inscricaoEstadual,
      inscricaoMunicipal,
      cnpj,
      nire,
      regionalComercial,
      unidadeDeNegocio,
      telefonePrincipal,
      emailPrincipal,
      dataDeFundacao,
      detalhesPodeMorar,
      emailComplementar,
      finalidadeDaCompra,
      tipoDeTrabalho,
      observacoes,

      telefonePrincipalEhWhatsapp,
      telefonePrincipalEhCelular,

      origemDaConta,
      empreendimentoDeInteressePrincipal,
      numeroDeQuartos,
      numeroDeVagas,
      criarOportunidade,
    };

    try {
      const response = await api.post("/conta/criar-pessoa-juridica", body);

      return response;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getCampaign() {
    try {
      const response = await api.get("/conta/obter-campanhas");

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
      return false;
    }
  }

  async createOportunity({
    regional,
    accountIdSalesforce,
    idCorretorSalesforce,
    nomeDaConta,
    nomeCorretor,
    telefonePrincipal,
    dataNascimento,
    nacionalidade,
    emailPrincipal,
    emailComplementar,
    faixaEtaria,
    sexo,
    empreendimentoDeInteressePrincipal,
    campanha,
    fase,
    origemConta,
    telefoneComplementar,
    regionalComercial,
  }: ICreateOportunitySchema) {
    const body = {
      regional,
      accountIdSalesforce,
      idCorretorSalesforce,
      nomeDaConta,
      nomeCorretor,
      telefonePrincipal,
      dataNascimento,
      nacionalidade,
      emailPrincipal,
      emailComplementar,
      faixaEtaria,
      sexo,
      empreendimentoDeInteressePrincipal,
      campanha,
      fase,
      origemConta,
      telefoneComplementar,
      regionalComercial,
    };

    try {
      const response = await api.post("/oportunidade/inserir", body);

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getOportunity({
    idCorretorSalesforce,
    DataInicio,
    DataFim,
    FlagNovoConceito,
    filtro,
    rank,
    filtroOrigemConta,
    filtroCriadorOportunidade,
    fase,
    clienteOuIdDaOportunidade,
    itensPorPagina,
    Pagina,
    ordenarPor,
    tipoOrdenacao,
  }: IGetOportunitySchema) {
    try {
      const response = await api.get("/oportunidade/obter", {
        params: {
          idCorretorSalesforce,
          DataInicio,
          DataFim,
          FlagNovoConceito,
          filtro,
          rank,
          filtroOrigemConta,
          filtroCriadorOportunidade,
          fase,
          clienteOuIdDaOportunidade,
          itensPorPagina,
          Pagina,
          ordenarPor,
          tipoOrdenacao,
        },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async getAccountById({ accountIdSalesforce }: IGetAccountByIdSchema) {
    try {
      const response = await api.get("/conta/obter-por-id", {
        params: { accountIdSalesforce },
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async updateAccount({
    AccountIdSalesforce,
    CPFCNPJ,
    DataExpedicaoRG,
    DataNascimento,
    EstadoCivil,
    Nacionalidade,
    Nome,
    OrgaoExpedidorRG,
    Profissao,
    RG,
    DataCasamento,
    RegimeCasamento,
    Email,
    regionalComercial,
    oportunidadeIdSalesforce,
    Sexo,
    Telefone,
  }: IUpdateAccount) {
    const body = {
      AccountIdSalesforce,
      CPFCNPJ,
      DataExpedicaoRG,
      DataNascimento,
      EstadoCivil,
      Nacionalidade,
      Nome,
      OrgaoExpedidorRG,
      Profissao,
      RG,
      DataCasamento,
      RegimeCasamento,
      Email,
      regionalComercial,
      oportunidadeIdSalesforce,
      Sexo,
      Telefone,
    };

    try {
      const response = await api.patch("/conta/atualizar", body);

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  async convertLead({
    leadId,
    telefone,
    email,
    nome,
    idCorretorSalesforce,
  }: IConvertLeadSchema) {
    try {
      const res = await api.post<{ accountId: string }>(
        "/lead/converter-lead",
        { leadId, telefone, email, idCorretorSalesforce },
      );

      return {
        success: true,
        nome,
        accountId: res.data.accountId,
        duplicated: false,
      };
    } catch (error) {
      if (error instanceof AxiosError) {
        return {
          success: false,
          nome,
          accountId: "",
          erro: error.response?.data?.erro,
          duplicated: error.response?.data?.duplicado,
        };
      } else {
        return {
          success: false,
          nome,
          accountId: "",
          erro: "",
          duplicated: false,
        };
      }
    }
  }

  async updateAdress(data: IUpdateAdress[]) {
    try {
      const response = await api.patch("/endereco-conta/atualizar", data, {
        // const response = await api.post("/endereco-conta/inserir", body, {
      });

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }
}

const salesServiceInstance = new SalesService();
export default salesServiceInstance;
